import { useQuery } from "@tanstack/react-query";

import { API_URL } from "@/constants/envVariables";
import { fetchApi } from "@/helpers/fetchApi";
import { AppError } from "@/types";

type UserOrgsResponse = {
  id: number;
  user_id: string;
  public_key: string;
  organization_name: string;
  organization_domain: string | null;
  recovery_method: string;
  multisig_configured: boolean;
} | null;

export const useGetUserOrgs = (receiverId: string | undefined, walletId: string | undefined, enabled: boolean = true) => {
  return useQuery<UserOrgsResponse, AppError>({
    queryKey: ["recovery", "user-orgs", receiverId, walletId],
    queryFn: async () => {
      return await fetchApi(
        `${API_URL}/receivers/${receiverId}/wallets/${walletId}/recovery/user-orgs`,
      );
    },
    enabled: !!receiverId && !!walletId && enabled,
    staleTime: Infinity,
  });
};
